export default "__VITE_ASSET__WxIYn_sY__"